module.exports = __webpack_public_path__ + "media/images/icons/flags/FR-119f07b2a719e49d19216be830a309a3.svg";